import { useQuery } from '@tanstack/react-query'
import axios from 'axios'
import { login, getIconData, getLocalStorageKey } from '../helper'
import { PINFLAG_PRIMARY_COLOR, COMPANY_API_URL } from '../constants/urls'
import { COMPANY_STALE_TIME } from '../constants/queryConstants'

export const fetchCompanyPersonalization = async (token) => {
  try {
    login(token)

    const { data } = await axios.get(`${COMPANY_API_URL}/company/personalization`, {
      headers: { 'x-api-key': token }
    })

    const { baseIconPath, timestamp } = await getIconData(data)

    const result = {
      baseIconPath,
      timestamp,
      primaryColor: data.primaryColor ?? PINFLAG_PRIMARY_COLOR,
      secondaryColor: data.secondaryColor ?? '#173554'
    }

    const payload = { ...result, fetchedAt: Date.now() }
    localStorage.setItem(getLocalStorageKey(token), JSON.stringify(payload))

    return result
  } catch (error) {
    const fallback = {
      primaryColor: PINFLAG_PRIMARY_COLOR,
      secondaryColor: '#173554',
      baseIconPath: 'icons',
      timestamp: ''
    }

    const storageKey = getLocalStorageKey(token)
    localStorage.setItem(storageKey, JSON.stringify({ ...fallback, fetchedAt: Date.now() }))

    return fallback
  }
}

export const useCompanyPersonalization = (token) =>
  useQuery({
    queryKey: ['companyPersonalization', token],

    queryFn: () => fetchCompanyPersonalization(token),

    staleTime: COMPANY_STALE_TIME,

    onError: (error) => {
      console.error('Error fetching company personalization:', error)
    },

    initialData: () => {
      const storageKey = getLocalStorageKey(token)
      const savedData = localStorage.getItem(storageKey)
      if (savedData) {
        try {
          return JSON.parse(savedData)
        } catch (error) {
          console.error('Invalid data in localStorage, clearing it:', error)
          localStorage.removeItem(storageKey)
        }
      }
      return undefined
    },

    initialDataUpdatedAt: () => {
      const storageKey = getLocalStorageKey(token)
      const savedData = localStorage.getItem(storageKey)
      return savedData ? JSON.parse(savedData)?.fetchedAt || 0 : undefined
    }
  })
